var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import useVisibility from '../hooks/useVisibility';
export var StickyMode;
(function (StickyMode) {
    StickyMode[StickyMode["default"] = 0] = "default";
    StickyMode[StickyMode["stickyInParent"] = 1] = "stickyInParent";
    StickyMode[StickyMode["stickyOutsideViewport"] = 2] = "stickyOutsideViewport";
})(StickyMode || (StickyMode = {}));
var StickyWrapper = function (_a) {
    var mode = _a.mode, testid = _a.testid, stickyOverwrite = _a.stickyOverwrite, children = _a.children;
    if (mode === StickyMode.stickyInParent) {
        return React.createElement(StickyWrapperInsideParent, { "data-testid": testid }, children);
    }
    if (mode === StickyMode.stickyOutsideViewport) {
        return (React.createElement(StickyWrapperWhenOutsideViewport, { "data-testid": testid, stickyOverwrite: stickyOverwrite }, children));
    }
    return React.createElement(StickyWrapperDefault, { "data-testid": testid }, children);
};
var StickyWrapperDefault = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 100%;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n"], ["\n  display: block;\n  width: 100%;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  left: 0;\n"])));
var StickyWrapperInsideParent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n  z-index: 10;\n"], ["\n  position: sticky;\n  top: 0;\n  z-index: 10;\n"])));
var StickyWrapperWhenOutsideViewport = function (_a) {
    var stickyOverwrite = _a.stickyOverwrite, children = _a.children;
    var stickyContent = stickyOverwrite ? (React.createElement("div", { "data-testid": "sticky-wrapper-overwrite" }, stickyOverwrite)) : (children);
    var _b = useVisibility(false, true), currentRef = _b[0], isVisible = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { "data-testid": "sticky-wrapper-static", ref: currentRef }, children),
        !isVisible && (React.createElement(StickyWrapperDefault, { "data-testid": "sticky-wrapper-sticky" }, stickyContent))));
};
export default StickyWrapper;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map